<template>
  <transition name="fade-zoom" :duration="200" mode="in-out">
    <component :is="modal" v-if="modal" v-bind="props" @hide="$emit('hide')" />
  </transition>
</template>

<script>
export default {
  name: "modal-container",

  props: {
    modal: Object,
    props: Object
  },

  watch: {
    modal(x) {
      // Disable page scrolling if modal is being displayed
      document.documentElement.classList[x ? "add" : "remove"]("is-clipped");
    }
  }
};
</script>

<style></style>
